/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import EnterpriseAdminSideNavigation from 'bundles/enterprise-admin-navigation/components/side-nav/EnterpriseAdminSideNavigation';
import { useEnterpriseAdminContext } from 'bundles/enterprise-admin/EnterpriseAdminContext';
import { useThirdPartyOrganization } from 'bundles/enterprise-admin/ThirdPartyOrganizationProvider';

const styles = {
  sideNavShell: css`
    display: grid;
    grid-template-columns: auto 1fr;
    height: 100vh;
    overflow: hidden;
  `,
  sideNavContentCell: css`
    min-width: 0;
    min-height: 0;
    overflow: auto;
    height: 100%;
    position: relative;
    scrollbar-gutter: stable;
  `,
};

const WithGlobalSideNavAndStyleGuide = ({ children, ...props }: React.PropsWithChildren<{}>) => {
  const org = useThirdPartyOrganization();
  const { adminRoleType } = useEnterpriseAdminContext();

  return (
    <div className="styleguide rc-AdminSideNavLayout" css={styles.sideNavShell}>
      <EnterpriseAdminSideNavigation thirdPartyOrganization={org} adminRoleType={adminRoleType} />
      <div css={styles.sideNavContentCell}>
        {React.isValidElement(children) ? React.cloneElement(children, props) : children}
      </div>
    </div>
  );
};

export default WithGlobalSideNavAndStyleGuide;
